import {
  EventTemplateTranslation,
  Translation,
  NewTranslation,
  VenueTemplateTranslation,
  ContentTemplateTranslation,
  AutoResolveConflict,
  SegmentTranslation,
  LevelTranslation,
  AttributeTranslation,
  VenueTypeTranslation,
  MealPeriodTranslation,
  DayThemeTranslation,
  HighlightTranslation,
  CommonTextTranslation,
  ContentLevelTranslation,
  ContentSegmentTranslation,
  ContentAttributeTranslation,
  TimeGroupingTranslation,
} from '@go-shared/types/translation';
import { apiGet, apiPost, apiRequest, RequestMethod } from '.';
import { TranslationFiltersSimple } from '@go-shared/lib/translation';

export async function getTranslations(
  propertyId: string,
  type: 'eventtemplate'
): Promise<EventTemplateTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'venuetemplate'
): Promise<VenueTemplateTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'contenttemplate'
): Promise<ContentTemplateTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'segment'
): Promise<SegmentTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'level'
): Promise<LevelTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'attribute'
): Promise<AttributeTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'contentSegment'
): Promise<ContentSegmentTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'contentLevel'
): Promise<ContentLevelTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'contentAttribute'
): Promise<ContentAttributeTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'venuetype'
): Promise<VenueTypeTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'mealperiod'
): Promise<MealPeriodTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'daytheme'
): Promise<DayThemeTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'highlight'
): Promise<HighlightTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'commonText'
): Promise<CommonTextTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: 'timeGrouping'
): Promise<TimeGroupingTranslation[]>;
export async function getTranslations(
  propertyId: string,
  type: Translation['type']
): Promise<Translation[]> {
  return apiGet(`/property/${propertyId}/translation`, { type });
}

export async function exportTranslationsToCSV(
  propertyId: string,
  type: Translation['type'],
  filters?: TranslationFiltersSimple
) {
  return apiPost<{ location: string }>(`/property/${propertyId}/translation-export`, filters, {
    type,
  });
}

export async function importTranslationsFromCSV(
  propertyId: string,
  type: 'eventtemplate',
  file: File
) {
  const fd = new FormData();
  fd.append('file', file);

  return apiRequest<{ location: string; count: number }>(
    RequestMethod.Post,
    `/property/${propertyId}/translation-import`,
    true,
    { type },
    fd,
    {
      'Content-Type': 'multipart/form-data',
    }
  );
}

export async function getTranslationsByRefers(
  type: 'eventtemplate',
  refers: string[]
): Promise<EventTemplateTranslation[]>;
export async function getTranslationsByRefers(
  type: 'venuetemplate',
  refers: string[]
): Promise<VenueTemplateTranslation[]>;
export async function getTranslationsByRefers(
  type: 'contenttemplate',
  refers: string[]
): Promise<ContentTemplateTranslation[]>;
export async function getTranslationsByRefers(
  type: 'segment',
  refers: string[]
): Promise<SegmentTranslation[]>;
export async function getTranslationsByRefers(
  type: 'level',
  refers: string[]
): Promise<LevelTranslation[]>;
export async function getTranslationsByRefers(
  type: 'attribute',
  refers: string[]
): Promise<AttributeTranslation[]>;
export async function getTranslationsByRefers(
  type: 'contentSegment',
  refers: string[]
): Promise<ContentSegmentTranslation[]>;
export async function getTranslationsByRefers(
  type: 'contentLevel',
  refers: string[]
): Promise<ContentLevelTranslation[]>;
export async function getTranslationsByRefers(
  type: 'contentAttribute',
  refers: string[]
): Promise<ContentAttributeTranslation[]>;
export async function getTranslationsByRefers(
  type: 'venuetype',
  refers: string[]
): Promise<VenueTypeTranslation[]>;
export async function getTranslationsByRefers(
  type: 'mealperiod',
  refers: string[]
): Promise<MealPeriodTranslation[]>;
export async function getTranslationsByRefers(
  type: 'daytheme',
  refers: string[]
): Promise<DayThemeTranslation[]>;
export async function getTranslationsByRefers(
  type: 'highlight',
  refers: string[]
): Promise<HighlightTranslation[]>;
export async function getTranslationsByRefers(
  type: 'commonText',
  refers: string[]
): Promise<CommonTextTranslation[]>;
export async function getTranslationsByRefers(
  type: 'timeGrouping',
  refers: string[]
): Promise<TimeGroupingTranslation[]>;
export async function getTranslationsByRefers(
  _type: Translation['type'],
  refers: string[]
): Promise<Translation[]> {
  return apiPost(`/translation`, { refers });
}

export async function resolveTranslationConflicts(
  propertyId: string,
  conflict: AutoResolveConflict
) {
  return apiPost(`/property/${propertyId}/translation-conflict`, conflict);
}

export async function replaceTranslationByRefer(
  referId: string,
  translation: NewTranslation
): Promise<Translation> {
  return apiPost(`/translation-refer/${referId}`, translation);
}
